import * as React from 'react';

import { Box, Divider, Stack, Typography } from '@mui/material';

interface FlightSegmentCrewStackProps {
  captain?: string | null;
  firstOfficer?: string | null;
  flightAttendant1?: string | null;
  flightAttendant2?: string | null;
}

function FlightSegmentCrewStack({
  captain,
  firstOfficer,
  flightAttendant1,
  flightAttendant2,
}: FlightSegmentCrewStackProps) {
  return (
    <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
      {captain && (
        <Box>
          <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>CA: </Typography>
          <Typography variant="body2" component="span">{captain}</Typography>
        </Box>
      )}
      {firstOfficer && (
        <Box>
          <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>FO: </Typography>
          <Typography variant="body2" component="span">{firstOfficer}</Typography>
        </Box>
      )}
      {flightAttendant1 && (
        <Box>
          <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>FA: </Typography>
          <Typography variant="body2" component="span">{flightAttendant1}</Typography>
        </Box>
      )}
      {flightAttendant2 && (
        <Box>
          <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>FA: </Typography>
          <Typography variant="body2" component="span">{flightAttendant2}</Typography>
        </Box>
      )}
    </Stack>
  );
}

export default FlightSegmentCrewStack;
